<template>
  <div class="product">
    <div class="product__image-wrapper">
      <Picture :images="firstImage" />
    </div>
    <div class="product__details">
      <div class="product__title">{{ productTitle }}</div>
      <div
        v-for="variant in merchandiseSelectedOptions"
        :key="variant.name"
        class="product__variant"
      >
        <span class="variant-title">{{ variant.value }}</span>
      </div>
      <div class="product__price">{{ formattedPrice }}</div>
      <div class="product__quantity">
        <NumberStepper
          :count="quantity"
          :max="maxQuantity"
          @change="onQuantityChange"
        />
        <button
          class="remove-product-button"
          type="button"
          @click="$emit('removeLine')"
        >
          Remove
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { unwrapNodes } from "@/helpers/graphql";
import Picture from "@/components/Picture.vue";
import NumberStepper from "@/components/NumberStepper";

export default {
  name: "CartLine",
  components: {
    NumberStepper,
    Picture,
  },
  props: {
    line: {
      type: Object,
      required: true,
    },
  },
  emits: ["removeLine", "updateLine"],
  computed: {
    productTitle() {
      return this.line.merchandise.product.title;
    },
    merchandiseSelectedOptions() {
      return this.line.merchandise.selectedOptions;
    },
    firstImage() {
      const images = unwrapNodes(this.line.merchandise.product.images.edges);
      return images ? images[0] : null;
    },
    quantity() {
      return this.line.quantity;
    },
    maxQuantity() {
      return this.line.merchandise.quantityAvailable;
    },
    formattedPrice() {
      const { amount, currencyCode } = this.line.merchandise.priceV2;
      return this.$filters.toCurrency(amount, currencyCode, 0);
    },
  },
  methods: {
    onQuantityChange(val) {
      this.$emit("updateLine", val);
    },
  },
};
</script>

<style lang="scss" scoped>
.product {
  display: flex;
  font-size: 9px;
  font-weight: 600;

  &__image-wrapper {
    flex: 1 0 15%;
    margin-right: 20px;
  }

  &__image {
    max-width: 100%;
    height: auto;
  }

  &__details {
    flex: 1 0 calc(60% - 20px);
  }

  &__title {
    font-family: $heading-font-family;
    font-size: 12px;
    text-transform: uppercase;
    margin-bottom: 10px;
    font-weight: normal;
  }

  &__variant {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
  }

  &__price {
    margin-bottom: 12px;
  }

  &__quantity {
    display: flex;
    justify-content: space-between;
  }
}

.edit-variant-button,
.remove-product-button {
  outline: none;
  background: none;
  border: none;
  font-size: 10px;
}
</style>
